import { AlertIcon as ChakraAlertIcon } from "@chakra-ui/react";

export const AlertIcon = ChakraAlertIcon;

/**
 * @typedef {import("@chakra-ui/react").AlertIconProps} AlertIconProps
 */
